<template>
  <div class="bg-white sticky-top">
    <b-button-toolbar justify clearfix>
        <b-button class="float-left right-arrow"
                  variant="link"
                  pill
                  v-if="links.prev"
          @click="fetchBooks({'endpoint': links.prev.href, 'status': meta.status}, false)">&lt;&lt; prev page&nbsp;&nbsp;&nbsp;&nbsp</b-button>
        <b-button
          disabled
          class="float-left right-arrow"
          variant="link"
          pill
          v-if="!links.prev"></b-button>
        <b-button-group>
          <b-button
            class="col status mw-100"
            variant="text-muted"
            pill>
            {{ meta.max_results * (meta.page - 1)}}-{{Math.min(meta.page * meta.max_results, meta.total) }} of {{ meta.total }} ({{ meta.status.trimRight() }}{{ downloadStatus.trimRight() }})</b-button>
          <b-button
            v-if="$route.path.startsWith('/search')"
            id="wget"
            class="statuslink"
            @click="downThemAll($route.path, 'txt')"><i>.txt</i></b-button>
          <b-button
            v-if="$route.path.startsWith('/search')"
            id="meta4"
            class="statuslink"
            @click="downThemAll($route.path, 'meta4')"><i>.meta4</i></b-button>
          <b-tooltip
            v-if="$route.path.startsWith('/search')"
            target="wget">
            This plain text file is generated against the search query: <span style="font-size: 1.1em;font-style: italic;">'{{meta.status.toLowerCase()}}'</span> and it contains the resulting links for all of the <span style="font-size: 1.1em;font-style: italic;">{{meta.total}}</span> books. To download all of them at once one should type in the terminal shell:<p style="font-size:1.3em;text-align:left; background-color:darkgreen;color:orange;">wget -cxnH -i links.txt</p>
          </b-tooltip>
          <b-tooltip
            v-if="$route.path.startsWith('/search')"
            target="meta4">
            This metalink4 XML file is generated against the search query: <span style="font-size: 1.1em;font-style: italic;">'{{meta.status.toLowerCase()}}'</span> and it contains the resultihng links for all of the <span style="font-size: 1.1em;font-style: italic;">{{meta.total}}</span> books. To download all of them at once one should type in the terminal shell:<p style="font-size:1.3em;text-align:left; background-color:darkgreen;color:orange;">aria2c -c links.meta4</p>
          </b-tooltip>
        </b-button-group>
        <b-button
          class="float-right left-arrow"
          variant="link"
          pill
          v-if="links.next"
          @click="fetchBooks({'endpoint': links.next.href, 'status': meta.status}, true)">&nbsp;&nbsp;&nbsp;&nbsp;next page &gt;&gt;</b-button>
        <b-button
          disabled
          class="float-right left-arrow"
          variant="link"
          pill
          v-if="!links.next"></b-button>
    </b-button-toolbar>
    </div>
</template>

<script>
    import {
        eventBus,
    } from '../main';

    export default {
        props: [
            'links',
            'downloadStatus',
            'meta'
        ],
        methods: {
            downThemAll(query, format) {
                let axiosConfig = this.$http.defaults;
                let q = encodeURI(query);
                let url = `${axiosConfig.baseURL}${q}?dl=${format}`
                console.log(url)
                window.open(url)
            },
            fetchBooks(searchQuery, reload) {
                if (reload) {
                    document.querySelectorAll(".card").forEach(
                        function(n) {
                            n.firstElementChild.src = "data:image/gif;base64,R0lGODlhAQABAIABAP///wAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
                        })
                }
                this.$store.state.searchQuery = searchQuery;
                eventBus.$emit('reloadSearch');
            }
        }
    }
</Script>

<style scoped>
    .right-arrow {
        color: #007bff !important;
        font-weight: normal;
        text-align: right !important;
        background-color: white !important;
    }

    .left-arrow {
        color: #007bff !important;
        font-weight: normal;
        text-align: left !important;
        background-color: white !important;
    }

    .status,
    .statuslink {
        color: black !important;
        font-weight: bold;
        background-color: white !important;
        padding-top: 0.5em;
        text-decoration: none !important;
    }

    .status:hover {
        cursor: default;
    }

    .statuslink:hover {
        text-decoration: underline !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue